import { Game } from '../types';

const games: Game[] = [
  {
    id: 'number-quest',
    name: 'Number Quest',
    description: 'Help a character collect treasures by solving addition and subtraction problems.',
    category: 'Math',
    icon: 'number-quest.png',
    path: '/games/number-quest',
    color: '#2196F3'
  },
  {
    id: 'pattern-puzzle',
    name: 'Pattern Puzzle',
    description: 'Complete sequences by identifying patterns in numbers and shapes.',
    category: 'Math',
    icon: 'pattern-puzzle.png',
    path: '/games/pattern-puzzle',
    color: '#4CAF50'
  },
  {
    id: 'sentence-scramble',
    name: 'Sentence Scramble',
    description: 'Unscramble words to form simple sentences with picture clues.',
    category: 'English',
    icon: 'sentence-scramble.png',
    path: '/games/sentence-scramble',
    color: '#9C27B0'
  },
  {
    id: 'phonics-factory',
    name: 'Phonics Factory',
    description: 'Match sounds to letters to build and spell words with audio cues.',
    category: 'English',
    icon: 'phonics-factory.png',
    path: '/games/phonics-factory',
    color: '#FF5722'
  },
  {
    id: 'times-tables-adventure',
    name: 'Times Tables Adventure',
    description: 'Learn multiplication with fun visual aids and interactive cards.',
    category: 'Math',
    icon: 'times-tables.png',
    path: '/games/times-tables-adventure',
    color: '#E91E63'
  },
  {
    id: 'vocabulary-vault',
    name: 'Vocabulary Vault',
    description: 'Unlock the treasure vault by spelling words from 3-10 letters correctly.',
    category: 'English',
    icon: 'vocabulary-vault.png',
    path: '/games/vocabulary-vault',
    color: '#FF9800'
  },
  {
    id: 'comparison-champions',
    name: 'Comparison Champions',
    description: 'Learn to compare weights, sizes, and quantities in fun visual challenges.',
    category: 'Math',
    icon: 'comparison-champions.png',
    path: '/games/comparison-champions',
    color: '#607D8B'
  }
];

export default games;
